module.exports = __webpack_public_path__ + "img/arrow-down-right.ca329fd9.svg";